<template>
  <div class="serveCard">
    <div class="serveCard-top">
      <img :src="item.imgUrl" alt="" />
    </div>
    <div class="serveCard-btm">
      <p class="serveCard-btm-title mb-8" :title="item.name">
        {{ item.name.length > 13 ? item.name.slice(0, 13) : item.name }}
      </p>
      <Tooltip
        max-width="300"
        :content="introduce"
        placement="top"
        v-if="descTip"
      >
        <p class="serveCard-btm-desc">
          {{ item.introduce }}
        </p>
      </Tooltip>
      <p v-else class="serveCard-btm-desc ">
        {{ item.introduce }}
      </p>
      <div class="serveCard-btm-star">
        <Rate disabled allow-half v-model="item.score" />
      </div>
      <div class="serveCard-btm-company mt-8">
        <p>{{ item.createTime }}</p>
      </div>
      <div class="serveCard-btm-use mt-8">
        <span class="useFont">{{ item.usedAmount }}</span>
        <span class="ml-6">使用量</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    item: Object,
  },
  data() {
    return {
      descTip: false,
      introduce: ""
    };
  },
  watch: {
    item: {
      handler(nval, oval) {
        // 切换页码，item改变，不会重新走vue生命周期
        this.getDesc();
      },
      deep: true,
    },
  },
  created() {
    this.getDesc();
  },
  methods: {
    getDesc() {
      console.log("xiugia");
      if (this.item.introduce.length > 34) {
        this.descTip = true;
        this.introduce = this.item.introduce;
        this.item.introduce = this.item.introduce.slice(0, 31) + "...";
      }
    },
  },
};
</script>
<style lang="scss">
.serveCard {
  &-top {
    height: 206px;
    img {
      width: 100%;
      height: 206px;
    }
  }
  &-btm {
    border-radius: 0px 0px 6px 6px;
    border: 1px solid rgba(151, 151, 151, 0.2);
    border-top: unset;
    padding: 16px;
    background: #ffffff;
    &-title {
      font-size: 20px;
      font-family: MicrosoftYaHeiSemibold;
      color: #2f4061;
      line-height: 27px;
    }
    &-desc {
      height: 44px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #67799c;
    }
    &-company {
      height: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
    }
    &-use {
      .useFont {
        font-size: 24px;
        font-family: Altinn-DINExp-Bold, Altinn-DINExp;
        font-weight: bold;
        color: #4d79ff;
      }
    }
  }
}
.serveCard:hover {
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0px 0px 6px 6px;
}
</style>